import React, { useState } from "react";
import FieldInput from "../../../../components/ModuleCommon/FormBuilder/FieldInput";
import Button from "../../../../components/ACS-Dashboard/ACS-Blocks/Button";
import FormLane from "./FormLane";

const FormContract = ({
  laneIds = [],
  onLanesUpdate,
  onAddRoute,
  children,
}) => {
  const [showLaneForm, setShowLaneForm] = useState(false);
  const [newRouteVisible, setNewRouteVisible] = useState(false);

  const handleLaneChange = (index, value) => {
    const newLanes = [...laneIds];
    newLanes[index] = value;
    onLanesUpdate(newLanes);
  };

  const handleAddLaneField = () => {
    onLanesUpdate([...laneIds, ""]);
  };

  const handleRemoveLane = (index) => {
    onLanesUpdate(laneIds.filter((_, i) => i !== index));
  };

  const handleNewLaneSubmit = (newLaneId) => {
    onLanesUpdate([...laneIds, newLaneId]);
    setShowLaneForm(false);
  };
  return (
    <div className="w-full bg-white rounded-md shadow-lg p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        Contract Associations Management
      </h2>

      {/* 关联Lane管理 - 始终显示 */}
      <div className="mb-8">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Transportation Lanes</h3>
          <Button
            text={showLaneForm ? "Cancel Lane Creation" : "Create New Lane"}
            variant="primary"
            onClick={() => setShowLaneForm(!showLaneForm)}
          />
        </div>

        {/* 内联表单 */}
        {showLaneForm && (
          <div className="mb-6 border-l-4 border-blue-200 pl-4">
            <FormLane
              onSuccess={(newLaneId) => {
                handleNewLaneSubmit(newLaneId);
                setShowLaneForm(false);
              }}
              onCancel={() => setShowLaneForm(false)}
            />
          </div>
        )}

        <div className="space-y-3">
          {laneIds.map((laneId, index) => (
            <div key={index} className="flex items-center gap-3">
              <FieldInput
                type="text"
                value={laneId}
                onChange={(val) => handleLaneChange(index, val)}
                placeholder="Enter Lane ID"
                className="flex-1"
              />
              <Button
                text="Remove"
                variant="outline"
                onClick={() => handleRemoveLane(index)}
              />
            </div>
          ))}
        </div>
      </div>
      {/* 关联Route管理 - 条件显示 */}
      {laneIds.length > 0 && (
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold">Shipping Routes</h3>
            <Button
              text="Add New Route"
              variant="primary"
              onClick={() => setNewRouteVisible(true)}
              disabled={!laneIds.length}
            />
          </div>
          {children}
        </div>
      )}
    </div>
  );
};

export default FormContract;
